import React, { useContext } from 'react';
import { Icon, SearchBox } from 'office-ui-fabric-react';

import { Styled } from './MapPage.styles';
import { mapContext } from './mapContext';

import { mainCordovaContext } from '../context';
import { AddressSearch } from './AddressSearch';
import { useHistory } from 'react-router';

import mapLayersIcon from 'images/layers.svg';
import zoomInIcon from 'images/zoom-in.svg';
import zoomOutIcon from 'images/zoom-out.svg';
import userIcon from 'images/user.svg';
import searchIcon from 'images/search.svg'

export const Controls: React.FC = () => {
  const { toggleNavigation } = useContext(mainCordovaContext);
  const {
    toggleShowLayersPopup,
    centerOnUser,
    toggleShowEntitiesSearchPopup,
    isBc,
    mapRef,
  } = useContext(mapContext);

  const history = useHistory();

  const handleZoomIn = () => {
    const map = mapRef?.current?.leafletElement;
    if (map) {
      map.zoomIn();
    }
  };
  const handleZoomOut = () => {
    const map = mapRef?.current?.leafletElement;
    if (map) {
      map.zoomOut();
    }
  };

  return (
    <>
      <Styled.RightBlock>
        <Styled.Button onClick={toggleShowLayersPopup}>
          {/*{isBc ? */}
          <img src={mapLayersIcon} alt="Слои" />
          {/* : <Icon iconName="MapLayers"/>}*/}
        </Styled.Button>

        <Styled.Button onClick={handleZoomIn}>
          <img src={zoomInIcon} alt="Приблизить" />
        </Styled.Button>

        <Styled.Button onClick={handleZoomOut}>
          <img src={zoomOutIcon} alt="Отдалить" />
        </Styled.Button>

        {!isBc && (
          <Styled.Button onClick={toggleShowEntitiesSearchPopup}>
            <img src={searchIcon} alt="Поиск" />
          </Styled.Button>
        )}

        <Styled.Button onClick={centerOnUser}>
          <img src={userIcon} alt="Центрировать на пользователе" />
        </Styled.Button>
      </Styled.RightBlock>
      {!isBc && <AddressSearch />}
    </>
  );
};
